// Type-only import: the embedded admin never bundles server code.
import type { ShopifyAdminAppRouter } from "@loot-os/functions/src/dashboard-api/trpc/shopifyAdmin/router.js";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";

/** The dashboard API, where the `shopifyAdmin` router is mounted at `/shopify-trpc`. */
const DASHBOARD_API_URL = import.meta.env.VITE_DASHBOARD_API_URL.toString().replace(/\/+$/, "");

export const { TRPCProvider, useTRPC } = createTRPCContext<ShopifyAdminAppRouter>();

/**
 * Every call carries a fresh App Bridge ID token: it is how the server knows the shop and the
 * staff member, and the first call from a shop is what installs it (token exchange).
 */
export const trpcClient = createTRPCClient<ShopifyAdminAppRouter>({
  links: [
    httpBatchLink({
      url: `${DASHBOARD_API_URL}/shopify-trpc`,
      headers: async () => ({ authorization: `Bearer ${await shopify.idToken()}` }),
    }),
  ],
});
